var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"visible":_vm.showModal,"title":_vm.title}},[_c('b-icon',{staticClass:"icon",attrs:{"variant":"primary","icon":_vm.iconName}}),_c('h5',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.description))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }